import React from 'react';

const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '');
const n = (v) => Number(v || 0).toFixed(2);

export const SettlementWorking = ({ data }) => {
  const rows = data?.breakdown || [];
  if (!rows.length) return null;
  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden" data-testid="settlement-working">
      <p className="bg-gray-50 px-3 py-2 text-xs font-semibold text-gray-700">Calculation details (year by year)</p>
      <table className="w-full text-[11px]">
        <thead className="bg-gray-50 text-gray-500">
          <tr>
            <th className="text-left px-3 py-1.5">Period</th>
            <th className="text-left px-2 py-1.5">Leave earned</th>
            <th className="text-right px-2 py-1.5">C/F in</th>
            <th className="text-right px-2 py-1.5">Taken</th>
            <th className="text-right px-2 py-1.5">Lapsed</th>
            <th className="text-right px-3 py-1.5">Balance</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((c, i) => (
            <tr key={c.period_start} className="border-t border-gray-100 align-top" data-testid={`settlement-working-row-${i}`}>
              <td className="px-3 py-1.5 whitespace-nowrap">{fmt(c.period_start)} – {fmt(c.period_end)}</td>
              <td className="px-2 py-1.5">
                {c.segments.map((s) => (
                  <div key={s.from} className="text-gray-600">
                    {s.days}d ({n(s.months)} mo) × {s.rate} = <b>{n(s.earned)}</b>
                  </div>
                ))}
                {c.segments.length > 1 && <div className="text-gray-800">Total: <b>{n(c.earned)}</b></div>}
              </td>
              <td className="px-2 py-1.5 text-right">{n(c.carried_in)}</td>
              <td className="px-2 py-1.5 text-right text-rose-600">{c.taken ? `−${n(c.taken)}` : '—'}</td>
              <td className="px-2 py-1.5 text-right text-amber-700">{c.lapsed ? `−${n(c.lapsed)}` : '—'}</td>
              <td className="px-3 py-1.5 text-right font-semibold">{n(c.closing)}{c.is_current ? '' : ' → C/F'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="px-3 py-2 text-[10px] text-gray-500 border-t border-gray-100">
        Rate: 2 days/month in the first year of service, 2.5 days/month from the 1-year anniversary. Months = days ÷ 365 × 12.
        Carry forward is capped at each year end (per leave rule, default 15 days); the excess lapses.
        {data.manual_adjustment ? ` Manual adjustment: ${data.manual_adjustment > 0 ? '+' : ''}${n(data.manual_adjustment)} days.` : ''}
      </p>
    </div>
  );
};
